/**
 * Internacionalización.
 *
 * Decisión de la Fase 0 (§16.8): **claves desde el primer día, traducciones no.**
 *
 * Poner las claves ahora cuesta casi nada y evita la tarea ingrata de rastrear
 * cadenas sueltas por toda la interfaz más adelante. Mantener un `en` completo
 * en paralelo, con una sola clienta hispanohablante, sí cuesta: hay que
 * traducir cada cambio de copy dos veces, para nadie.
 *
 * El inglés entra cuando haya a quién servírselo (Fase 6, productización).
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { es } from './es.ts';

void i18n.use(initReactI18next).init({
  resources: { es: { translation: es } },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: {
    // React ya escapa por su cuenta; hacerlo dos veces rompe los acentos.
    escapeValue: false,
  },
});

export { i18n };
